import uibModalModule from 'angular-ui-bootstrap/src/modal';
import normalButtonComponentMod from '../../../common/material-components/buttons/normal-button.component';

import tpl from './maintenance_reminder.tpl.html';

/**
 * Refresh the maintenance modal countdown every this many seconds.
 * @type {number}
 */
const COUNTDOWN_REFRESH = 5;

class MaintenanceReminderModalComponent {
  constructor($interval) {
    'ngInject';

    this.$interval = $interval;
    this.resolve = null;

    /**
     * Maintenance starting time.
     * @type {Moment}
     */
    this.timeAt = null;

    /**
     * Duration to the expiry time in human readable form.
     * @type {string}
     */
    this.humanDuration = null;

    this.close = null;
    this.dismiss = null;
    this._refreshInterval = null;
  }

  $onInit() {
    this.timeAt = this.resolve.timeAt;
    this.updateDuration();

    this._refreshInterval = this.$interval(() => this.updateDuration(), COUNTDOWN_REFRESH * 1000);
  }

  $onDestroy() {
    this.$interval.cancel(this._refreshInterval);
  }

  updateDuration() {
    this.humanDuration = this.timeAt.fromNow(true);
  }
}

const config = {
  templateUrl: tpl,
  controller: MaintenanceReminderModalComponent,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

const mod = angular.module('app.common.keepalive.maintenanceReminderModal', [
  uibModalModule,
  normalButtonComponentMod
])

.component('maintenanceReminderModal', config)

.factory('openMaintenanceReminderModal', function ($uibModal) {
  return timeAt => $uibModal.open({
    component: 'maintenanceReminderModal',
    size: 'sm',
    resolve: {timeAt: () => timeAt}
  });
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/keepalive/maintenance_reminder.modal.js